var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDummyProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#E6E7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7059 28.1051C28.4601 28.1051 31.5035 25.0617 31.5035 21.3074C31.5035 17.5532 28.4601 14.5098 24.7059 14.5098C20.9516 14.5098 17.9082 17.5532 17.9082 21.3074C17.9082 25.0617 20.9516 28.1051 24.7059 28.1051Z",
    stroke: "#C0C2C2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4033 34.0534C15.4473 32.2447 16.9491 30.7428 18.7576 29.6985C20.5661 28.6543 22.6177 28.1045 24.706 28.1045C26.7944 28.1045 28.8459 28.6543 30.6544 29.6985C32.463 30.7428 33.9647 32.2447 35.0087 34.0534",
    stroke: "#C0C2C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummyProfile);
export default __webpack_public_path__ + "static/media/dummyProfile.f58f62cbe14bd19d662c9f448cb24a5c.svg";
export { ForwardRef as ReactComponent };